import {
  DeploymentSchemeRequest,
  DeploymentSchemeResults,
  DeploymentSchemeSearchArgs,
  DeploymentSchemeSimple,
  DeploymentSchemeWithGoals,
} from "types/deployment-schemes/deployment-scheme-types";

import API from "api/client";
import { envConfig } from "config";

const { deploymentSchemesAPI } = envConfig;

/**
 * Creates a DeploymentScheme along with its associated goals.
 */
const createDeploymentSchemeWithGoals = (req: DeploymentSchemeRequest): Promise<DeploymentSchemeWithGoals> => {
  return API.post(`${deploymentSchemesAPI}`, req).then((response) => {
    return response.data;
  });
};

/**
 * Deletes a DeploymentScheme by ID.
 */
const deleteDeploymentScheme = (id: number): Promise<void> => {
  return API.delete(`${deploymentSchemesAPI}${id}`).then((res) => res.data);
};

/**
 * Gets a DeploymentScheme by ID.
 */
const getDeploymentScheme = (id: number): Promise<DeploymentSchemeWithGoals> => {
  return API.get(`${deploymentSchemesAPI}${id}`).then((res) => res.data);
};

/**
 * Searches DeploymentSchemes with given parameters.
 */
const searchDeploymentSchemes = ({
  query,
  orderByTerm,
  orderTerm,
  page,
  size,
}: DeploymentSchemeSearchArgs): Promise<DeploymentSchemeResults> => {
  return API.get(deploymentSchemesAPI, {
    params: { query, orderBy: orderByTerm, order: orderTerm, page, size },
  }).then((res) => res.data);
};

/**
 * Gets all DeploymentSchemes for the current account.
 */
const getAllDeploymentSchemes = (): Promise<DeploymentSchemeSimple[]> => {
  return API.get(`${deploymentSchemesAPI}all`).then((res) => res.data);
};

/**
 * Updates a DeploymentScheme by ID.
 */
const updateDeploymentScheme = (id: number, req: DeploymentSchemeRequest): Promise<DeploymentSchemeWithGoals> => {
  return API.put(`${deploymentSchemesAPI}${id}`, req).then((res) => res.data);
};

export default {
  create: createDeploymentSchemeWithGoals,
  delete: deleteDeploymentScheme,
  get: getDeploymentScheme,
  getAll: getAllDeploymentSchemes,
  list: searchDeploymentSchemes,
  update: updateDeploymentScheme,
};
